import { styledBoxOptions, StyledBoxOptions } from '@/support/StyledBox';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<TypeFilter>({})
export default class TypeFilter extends Vue {
  @Prop()
  private value!: Item;

  @Prop({
    type: Array,
    default: () => styledBoxOptions,
  })
  private items!: StyledBoxOptions[]

  private handleInput(item: Item): void {
    this.$emit('input', item);
  }

}

type Item = {
  value: string;
  text: string;
};
